export const MATERIAL_CODES = {
  PLA: 'PLA',
  PETG: 'PETG',
  ABS: 'ABS',
  ASA: 'ASA',
  PP: 'PP',
  PC: 'PC',
  TPU: 'TPU',
};

export function pts(map = {}) {
  const out = {};
  if (!map || typeof map !== 'object') return out;
  for (const [key, value] of Object.entries(map)) {
    const code = String(key || '').trim().toUpperCase();
    if (!code) continue;
    const num = Number(value);
    if (!Number.isFinite(num)) continue;
    out[code] = num;
  }
  return out;
}

export const QUESTIONS = [
  {
    id: 'enclosure',
    label: 'Czy drukarka posiada komorę zamkniętą?',
    type: 'radio',
    options: [
      {
        value: 'yes',
        label: 'Tak',
        pointsByCode: pts({ ABS: 8, ASA: 8, PC: 8 }),
      },
      {
        value: 'no',
        label: 'Nie',
        pointsByCode: pts({ ABS: -100, ASA: -100, PC: -100 }),
      },
    ],
  },
  {
    id: 'environment',
    label: 'W jakich warunkach środowiskowych będzie używany wydruk?',
    type: 'select',
    options: [
        {
        value: 'e1',
        label: 'Wewnątrz, stabilne warunki',
        pointsByCode: pts({PLA: 8, PETG: 5, ABS: 4, ASA: 4, PP: 4, PC: 3, TPU: 3,}),
        },
        {
        value: 'e2',
        label: 'Wewnątrz, podwyższona wilgotność',
        pointsByCode: pts({PLA: 2, PETG: 6, ABS: 4, ASA: 5, PP: 6, PC: 4, TPU: 5,}),
        },
        {
        value: 'e3',
        label: 'Na zewnątrz, osłonięty',
        pointsByCode: pts({PLA: -10, PETG: 5, ABS: 5, ASA: 7, PP: 6, PC: 5, TPU: 4,}),
        },
        {
        value: 'e4',
        label: 'Na zewnątrz: UV',
        pointsByCode: pts({PLA: -25, PETG: 2, ABS: 4, ASA: 8, PP: 5, PC: 6, TPU: 2,}),
        },
        {
        value: 'e5',
        label: 'Na zewnątrz: UV, wilgoć, mróz',
        pointsByCode: pts({PLA: -35, PETG: -5, ABS: 3, ASA: 8, PP: 4, PC: 5, TPU: 0,}),
        },
    ],
    },
  {
    id: 'temperature',
    label: 'Jaka będzie maksymalna temperatura pracy wydruku?',
    type: 'select',
    options: [
    {
      value: 't1',
      label: 'Do 35 °C (warunki pokojowe, bez nagrzewania)',
      pointsByCode: pts({ PLA: 8, PETG: 6, ABS: 4, ASA: 4, PP: 4, PC: 3, TPU: 5 }),
    },
    {
      value: 't2',
      label: '35–50 °C (nagrzewanie pasywne np. słońce)',
      pointsByCode: pts({ PLA: 1, PETG: 6, ABS: 6, ASA: 6, PP: 5, PC: 5, TPU: 3 }),
    },
    {
      value: 't3',
      label: '50–70 °C (blisko źródła ciepła np. obudowy silniki)',
      pointsByCode: pts({ PLA: -15, PETG: 2, ABS: 7, ASA: 7, PP: 5, PC: 7, TPU: -5 }),
    },
    {
      value: 't4',
      label: '70–90 °C (ciągła praca w podwyższonej temperaturze)',
      pointsByCode: pts({ PLA: -30, PETG: -10, ABS: 6, ASA: 7, PP: 4, PC: 9, TPU: -15 }),
    },
    {
      value: 't5',
      label: 'Powyżej 90 °C (środowisko wysokotemperaturowe)',
      pointsByCode: pts({ PLA: -50, PETG: -30, ABS: 4, ASA: 6, PP: 3, PC: 10, TPU: -30 }),
    },
    ],
    },
  {
    id: 'chemicals',
    label: 'Stopień kontaktu z chemią, olejami lub paliwami',
    type: 'select',
    options: [
      {
        value: 'c1',
        label: 'Brak',
        pointsByCode: pts({ PLA: 3, PETG: 3, ABS: 3, ASA: 3, PP: 3, PC: 3, TPU: 3 }),
      },
      {
        value: 'c2',
        label: 'Sporadyczny',
        pointsByCode: pts({ PLA: -5, PETG: 2, ABS: 4, ASA: 4, PP: 6, PC: 3, TPU: 4 }),
      },
      {
        value: 'c3',
        label: 'Częsty',
        pointsByCode: pts({ PLA: -15, PETG: -5, ABS: 5, ASA: 5, PP: 8, PC: 4, TPU: 6 }),
      },
      {
        value: 'c4',
        label: 'Stały / agresywny',
        pointsByCode: pts({ PLA: -30, PETG: -15, ABS: 6, ASA: 6, PP: 10, PC: 5, TPU: 7 }),
      },
    ],
  },
  {
  id: 'flexibility',
  label: 'Elastyczność wyrobu',
  type: 'select',
  options: [
    {
      value: 'f1',
      label: 'Całkowicie sztywny',
      pointsByCode: pts({PLA: 6, PETG: 5, ABS: 9, ASA: 8, PP: 4, PC: 5, TPU: -100,}),
    },
    {
      value: 'f2',
      label: 'Sztywny z dopuszczalną sprężystością',
      pointsByCode: pts({PLA: 4, PETG: 5, ABS: 4, ASA: 4, PP: 5, PC: 4, TPU: -100,}),
    },
    {
      value: 'f3',
      label: 'Sprężysty',
      pointsByCode: pts({PLA: -6, PETG: -6, ABS: -5, ASA: -5, PP: -4, PC: -4, TPU: 7,}),
    },
    {
      value: 'f4',
      label: 'Bardzo elastyczny',
      pointsByCode: pts({PLA: -10, PETG: -5, ABS: -20, ASA: -20, PP: 2, PC: 1, TPU: 10,}),
    },
  ],
  },
  {
  id: 'lifetime',
  label: 'Jak długa ma być żywotność elementu?',
  type: 'select',
  options: [
    {
      value: 'life1',
      label: 'Prototyp',
      pointsByCode: pts({ PLA: 6, PETG: 4, ABS: 3, ASA: 3, TPU: 4, PP: 3 }),
    },
    {
      value: 'life2',
      label: 'Kilka lat w kontrolowanych warunkach',
      pointsByCode: pts({ PLA: 2, PETG: 5, ABS: 5, ASA: 6, TPU: 4, PP: 6 }),
    },
    {
      value: 'life3',
      label: 'Długotrwała praca w trudnym środowisku',
      pointsByCode: pts({ PLA: -20, PETG: 2, ABS: 6, ASA: 8, TPU: 5, PP: 8 }),
    },
  ],
  },
  {
  id: 'mechanicalLoad',
  label: 'Jakie obciążenia mechaniczne będzie przenosił element?',
  type: 'select',
  options: [
    {
      value: 'load1',
      label: 'Minimalne (osłona, dekoracja)',
      pointsByCode: pts({ PLA: 6, PETG: 4, ABS: 3, ASA: 3, Nylon: 2, TPU: 4, PP: 2 }),
    },
    {
      value: 'load2',
      label: 'Umiarkowane (zatrzaski, częste użycie)',
      pointsByCode: pts({ PLA: 2, PETG: 5, ABS: 5, ASA: 5, Nylon: 8, TPU: 5, PP: 6 }),
    },
    {
      value: 'load3',
      label: 'Wysokie (udar, tarcie, dynamiczne siły)',
      pointsByCode: pts({ PLA: -10, PETG: 2, ABS: 6, ASA: 6, Nylon: 9, TPU: 6, PP: 5 }),
    },
  ],
},
];

export const DEFAULT_ANSWERS = {
  enclosure: 'no',
  environment: 'e1',
  temperature: 't1',
  chemicals: 'c1',
  flexibility: 'f1',
  lifetime: 'life1',
  mechanicalLoad: 'load1',
};

export function scoreByQuestions({ materialCode, answers }) {
  const code = String(materialCode || '').trim().toUpperCase();
  if (!code) return 0;

  let score = 0;
  for (const q of QUESTIONS) {
    const answerValue = answers?.[q.id];
    const opt = q.options.find((o) => o.value === answerValue);
    if (!opt) continue;
    const pts = opt.pointsByCode?.[code];
    if (Number.isFinite(pts)) score += pts;
  }
  return score;
}
